export default __webpack_public_path__ + "static/media/pizza6.57c67b96.png";